import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';
import { SlugifyPipe } from '@shared/pipes/slugify.pipe';

@Component({
  selector: 'lib-form-input',
  styleUrls: ['form-input.component.scss'],
  templateUrl: 'form-input.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbTooltip,
    FormFieldErrorComponent,
    SlugifyPipe,
  ],
})
export class FormInputComponent extends FieldBaseComponent {}
